<script setup>
defineOptions({
  name: 'AuthLayout',
})
</script>

<template>
  <div class="relative min-h-screen bg-dss-secondary-500 overflow-hidden">
    <div class="absolute inset-0 z-10">
      <img
        src="@shared/assets/svg/big-plus-bg.svg?url"
        :alt="$t('core.layout.background-alt')"
        class="relative object-cover object-left h-full"
        aria-hidden="true"
      >
    </div>

    <div class="absolute inset-0">
      <img
        src="@shared/assets/images/404.jpeg"
        :alt="$t('core.layout.background-alt')"
        class="relative object-cover object-bottom-left h-full"
        aria-hidden="true"
      >
    </div>

    <div class="relative z-10 flex min-h-screen">
      <router-view />
    </div>
  </div>
</template>
